"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var services_1 = require("../../services");
function getMatchIdFromLocation(pathname) {
    if (pathname === void 0) { pathname = services_1.getHistory().location.pathname; }
    if (pathname.indexOf(types_1.App.Routes.MATCH) > -1) {
        return pathname.replace(types_1.App.Routes.MATCH, '');
    }
    return null;
}
exports.default = getMatchIdFromLocation;
//# sourceMappingURL=getMatchIdFromLocation.js.map